import { httpGetAndParse, httpPut } from '../../../utils/fetchService';

export const fetchFilingMembers = ({ taxYear, period, jurisdictionId, filingGroupId }) =>
  httpGetAndParse({
    route: `/api/state-filing-groups/filing-members/${taxYear}/${period}/${jurisdictionId}/${filingGroupId}`,
    errorMessage: 'Fetching filing members for state filing group failed',
  });

export const updateFilingMembers = rowsToUpdate =>
  httpPut({
    route: '/api/state-filing-groups/filing-members',
    errorMessage: 'Updating filing members failed',
    body: {
      payload: rowsToUpdate,
    },
  });
